import Loader from '@piconetworks/module-loader'

/* eslint-disable-next-line import/no-cycle */
import createDuck from '../baseDuck'

export default Loader({
    createDuck,
})
